import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import Snackbar from '../../../../../components/Snackbar';
import { makeStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionActions from '@material-ui/core/AccordionActions';
import AddNewContacts from '../../../../../components/AddNewContacts';
import NewContactAdded from '../../../../../components/AddNewContacts/NewContactAdded';
import './addNewContact.scss';

var Scroll = require('react-scroll');
var ElementScroll = Scroll.Element;
let { scroller } = Scroll;
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: 16,
    marginTop: 24,
  },
  title: {
    fontSize: 22,
    color: '#013957',
    borderBottom: 'thin solid #e7e7e7',
    paddingBottom: 8,
    marginBottom: 23,
    width: '100%',
  },
  text: {
    color: '#484848',
    lineHeight: 'normal',
  },
  seeMore: {
    fontWeight: 'bold',
    color: '#10587f',
    lineHeight: 'normal',
    marginRight: 8,
  },
  expandButton: {
    color: '#013957',
    cursor: 'pointer',
    margin: '0 0 3px 0',
  },
  summaryContent: {
    marginTop: 23,
    alignSelf: 'start',
  },
  divider: {
    border: '0.4px solid #e7e7e7',
    margin: '0 0 10px 0',
    width: '100%',
  },

}));

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    color: '#484848',
    borderRadius: 4,
    marginBottom: 8,
    '&::before': {
      height: 0,
    },
    '&$expanded': {
      margin: '24px 0',
    },
    '&$disabled': {
      backgroundColor: 'transparent',
      cursorPointer: 'not-allowed'
    }
  },
  disabled: {
    backgroundColor: 'transparent',
    cursor: 'not-allowed'
  }
})(Accordion);

const ExpansionPanelSummary = withStyles({
  root: {
    flexFlow: 'column',
    padding: 0,
    minHeight: 56,
    position: 'relative',
    backgroundColor: 'white',
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    width: '100%',
    flexFlow: 'column',
    alignItems: 'flex-start',
    cursor: 'auto',
    marginTop: 6,
    marginBottom: 8,

  },
  expandIcon: {
    color: '#013957',
  },
})(AccordionSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    padding: 0,
    display: 'block',
    borderRadius: 4,
  },
})(AccordionActions);
const AddNewContact = (props) => {
  const {
    contacts,
    setContacts,
  } = props;

  const classes = useStyles();
  const [expanded, setExpanded] = useState(false || !contacts.length === 0);

  const [nElem, setnElem] = useState(0);
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  const [helper, setHelper] = useState(false);
  const [isFull, setIsFull] = useState(false);
  const [totalElements, setTotalElements] = useState(0);

  const helperTrue = () => {
    if (isFull) {
      setHelper(true);
      setTotalElements((prev) => {
        if (prev) {
          return prev + 1;
        }
        return 1;
      });
      scroller.scrollTo('myScroll_NewContact', {
        smooth: true,
        offset: 676 * totalElements,
      });
    }
  };

  const helperFalse = () => {
    setHelper(false);
  };

  const getValues = (evaluation) => {
    setIsFull(evaluation);
  };

  const handleChange = (event) => {
        setExpanded(expanded ? false : true);
  };

  const changeStatus = (isActive) => {
    setExpanded(isActive ? true : false);
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  const handleSnackbar = () => {
    setFeedbackMessage({
      open: true,
      message: 'Se ha quitado el contacto exitosamente',
      variant: 'success',
    });
  };

  const [edit, setEdit] = useState();

  const handleEditFlag = (flag) => {
    setEdit(flag);
  };

  const objectHasSomething = (array) => {
    const allValues = Object.values(array.slice(0, 1));
    const evaluation = allValues.some((elem) => {
      if (elem !== '') {
        return true;
      }
      return false;
    });
    return evaluation;
  };

  const objectIsEmpty = (array) => {
    const allValues = Object.values(array.slice(0, 1));
    const evaluation = allValues.every((elem) => {
      if (elem === '') {
        return true;
      }
      return false;
    });
    return evaluation;
  };

  useEffect(() => {
    if (!expanded) {
      setIsFull(false);
    }
    contacts ? setnElem(contacts.length) : setnElem(0);
    contacts.length > 0 && setExpanded(false)
  }, [contacts, expanded]);

  return (
    <>
      <ElementScroll name="addNewContact">
        <div className="addNewContact">
          <ExpansionPanel expanded={expanded} disabled={contacts && contacts.length > 0}>
            <ExpansionPanelSummary
              aria-controls="panel2a-content"
              style={{ backgroundColor: 'white' }}
            >
              {!contacts || !contacts.length ? (
                <div
                  className={classes.expandButton}
                  onClick={handleChange}
                >
                  <p className="addNewContact_add">
                    <img className="plus" src="/img/profile/plus.svg" alt="" />
                    Añadir nuevo contacto
                  </p>
                  <p className="addNewContact_limit">
                    Puedes añadir un nuevo contacto en caso de que no lo tengas
                    agregado en tus contactos
                  </p>
                </div>
              ) : (
                <div
                  className={classes.expandButton}
                  onClick={handleChange}
                >
                  <p className="addNewContact_add">
                    <img className="plus" src="/img/profile/plus.svg" alt="" />
                    Añadir nuevo contacto
                  </p>
                  <p className="addNewContact_limit">
                    Puedes añadir un nuevo contacto en caso de que no lo tengas
                    agregado en tus contactos
                  </p>
                </div>
              )}

            </ExpansionPanelSummary>

            <ExpansionPanelDetails>
              <AddNewContacts
                evento={changeStatus}
                nElem={nElem}
                allContacts={contacts}
                helper={helper}
                helperTrue={helperTrue}
                helperFalse={helperFalse}
                getValues={getValues}
                setContacts={setContacts}
              />
            </ExpansionPanelDetails>
          </ExpansionPanel>

          {contacts ? (
            <NewContactAdded
              allContacts={contacts}
              handleSnack={handleSnackbar}
              handleEditFlag={handleEditFlag}
              nElem={nElem}
              helper={helper}
              helperTrue={helperTrue}
              helperFalse={helperFalse}
              getValues={getValues}
              setContacts={setContacts}
            />
          ) : null}
        </div>
      </ElementScroll>
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </>
  );
};

export default AddNewContact;

